import { useRef } from 'react';

import './InDepthCourse.scss';
import { BackButton } from '../index';
import { srcSet, useDimensions } from '../../helpers/image';

export default function InDepthCourse({ course }) {
  const ref = useRef();
  const dimensions = useDimensions(ref);

  return (
    <div className="inDepthCourse">
      <BackButton />

      <div className="inDepthCourse-header">
        <h1 className="inDepthCourse-header-name">{course.displayName}</h1>

        <div className="inDepthCourse-header-author">
          <div ref={ref} className="inDepthCourse-header-author-img">
            {dimensions && (
              <img
                alt="course-author-image"
                srcSet={srcSet(course.userImageUrl, dimensions)}
              />
            )}
          </div>

          <span className="inDepthCourse-header-author-name">
            {course.username}
          </span>
        </div>
      </div>
    </div>
  );
}
